export const AF = {
  translation: {},
};
